import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { statesSelector } from '../../store/selectors';
import { questionsConstants } from '../../../../constants/questions.constants';
import { setStates } from '../../store/actions';
import useQuestionsStates from '../../queries/useQuestionsStates';
import useFilterChange from '../../hooks/useFilterChange';
import { filterDelay } from '../../constants/common';

const SelectQuestionsStates = ({ className }) => {
  const selectedStates = useSelector(statesSelector);
  const [value, setValue] = useState(selectedStates);

  const { data: states, isFetching: isStatesFetching } = useQuestionsStates({
    staleTime: Infinity,
  });

  const change = useFilterChange({ action: setStates, delay: filterDelay });

  const handleChange = (values) => {
    setValue(values);
    change(values);
  };

  useEffect(() => {
    setValue(selectedStates);
  }, [selectedStates]);

  return (
    <Select
      className={className}
      loading={isStatesFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear
      placeholder="Статус"
      value={states?.length ? value : []}
      optionFilterProp="searchtext"
      onChange={handleChange}
    >
      {states?.map((state) => (
        <Select.Option key={state.id} value={state.id} searchtext={state.name}>
          {questionsConstants.questionStateIcon(state.id, 20)}
          <span style={{ marginLeft: '5px' }}>{state.name}</span>
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectQuestionsStates;
